import React, { useState } from "react";
import "./Login.css";
import axios from "axios"; // Import axios for API requests
import { ToastContainer, toast } from "react-toastify"; // Import react-toastify

import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigtion = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Validate inputs
    if (!username || !password) {
      toast.error("Username and password are required");
      return;
    }

    try {
      const response = await axios.post(
        "https://pricelist.rukmanimfg.com/api/admin/loginadmin",
        {
          username,
          password,
        }
      );

      // On successful login, show a success message
      toast.success("Login successful!");
      localStorage.setItem("tokenlogin", response.data.token);

      setTimeout(() => {
        navigtion("/pricelist");
      }, 1000);
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.msg || "Something went wrong");
    }
  };

  return (
    <div>
      <ToastContainer />
      <section className="login_section">
        <div className="login_form">
          <h2>Login</h2>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                className="form-control"
                id="username"
                placeholder="Enter your username"
                value={username}
                style={{ color: "rgba(49, 46, 46, 0.7)" }}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="Enter your password"
                value={password}
                style={{ color: "rgba(49, 46, 46, 0.7)" }}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Login
            </button>
          </form>
        </div>
      </section>

      {/* Render toast notifications */}
      <ToastContainer />
    </div>
  );
}

export default Login;
